export const websiteInfo = [
    {
      id: 1,
      title: 'FishSpot',
      short_desc: 'Node.js, Express, MongoDB',
      long_desc: 'FishSpot is a web app that allows users to track fishing locations. Users are able to log in and share their favorite spots. Includes account creation with google maps, user authentication, and commenting. Deployed on Heroku and DNS rerouted through my webhosting.',
      slug: 'thumb_1',
      modalRequired: true,
      alt: 'FishSpot Card',
      url: 'http://www.fishspot.clearorb.com',
      github: 'https://github.com/Miario/fishSpot'
    },
    {
      id: 2,
      title: 'Straight Cuts Barber',
      short_desc: 'HTML, CSS, Bootstrap',
      long_desc: 'A mobile first fully responsive website for a hypothetical barbar shop in the Happy Valley area. Features Google Maps, social media integration, a nice clean layout and a service menu.',
      slug: 'thumb_2',
      modalRequired: true,
      alt: 'Straight Cuts Barber Card',
      url: 'http://www.clearorb.com/straightcutsbarber/',
      github: ''
    },
    {
      id: 3,
      title: 'PB Steel Detailing',
      short_desc: 'HTML, CSS, Bootstrap',
      long_desc: 'PB Steel Detailing is a local company that produces detailed structural and steel shop drawings and blueprints.',
      slug: 'thumb_3',
      modalRequired: true,
      alt: 'PB Steel Detailing Card',
      url: 'http://www.pbsteeldetailing.com/',
      github: ''
    },
    {
      id: 4,
      title: 'PDX Auto Brokers',
      short_desc: 'HTML, CSS, Bootstrap',
      long_desc: 'PDX Auto Brokers based in Portland, OR. They specialize in finding clients the perfect car for the right prices. Full wireframe consisting of Responsive design, drop down menus and contact forms.',
      slug: 'thumb_4',
      modalRequired: true,
      alt: 'PDX Auto Brokers Card',
      url: 'http://www.clearorb.com/pdxautobrokers/',
      github: ''
    },
    {
      id: 5,
      title: 'PDX Auto Zone',
      short_desc: 'WordPress',
      long_desc: 'Built with Wordpress, the site features registration, posts, multiple galleries and social media.',
      slug: 'thumb_5',
      modalRequired: true,
      alt: 'PDX Auto Zone Card',
      url: 'http://www.pdxauto.clearorb.com',
      github: ''
    },
    {
      id: 6,
      title: 'SmartBrain',
      short_desc: 'Node.js, Express, PostgreSQL, React',
      long_desc: 'Fullstack app that allows a user to login in and post an image url. The app will then detect a face using the Clarafia face detect Api.',
      slug: 'thumb_6',
      modalRequired: true,
      alt: 'SmartBrain Card',
      url: 'http://www.smartbrain.clearorb.com',
      github: 'https://github.com/Miario/smart-brain'
    }
  ];

  export const projectInfo = [
    {
      id: 7,
      title: 'RoboFriends',
      short_desc: 'Node.js + React',
      slug: 'thumb_7',
      modalRequired: false,
      alt: 'RoboFriends Card',
      url: 'http://www.robofriends.clearorb.com',
      github: 'https://github.com/Miario/RoboFriends'
    },
    {
      id: 8,
      title: 'Wordbler',
      short_desc: 'Node, Express, MongoDB, React',
      slug: 'thumb_8',
      modalRequired: false,
      alt: 'Wordbler Card',
      url: 'https://wordbler-client.herokuapp.com/',
      github: 'https://github.com/Miario/Wordbler'
    },
    {
      id: 9,
      title: 'Patatap Clone',
      short_desc: 'JavaScript, Paper.js + Howler.js',
      slug: 'thumb_9',
      modalRequired: false,
      alt: 'Patatap Clone Card',
      url: 'http://www.clearorb.com/projects/patatapclone/index.html',
      github: ''
    },
    {
      id: 10,
      title: 'Crypto Calculator',
      short_desc: 'JavaScript',
      slug: 'thumb_10',
      modalRequired: false,
      alt: 'Crypto Calculator Card',
      url: 'http://www.clearorb.com/projects/cryptocalculator/index.html',
      github: 'https://github.com/Miario/CryptoCalculator'
    },
    {
      id: 11,
      title: 'RGB Color Game',
      short_desc: 'JavaScript',
      slug: 'thumb_11',
      modalRequired: false,
      alt: 'RGB Color Game Card',
      url: 'http://www.clearorb.com/projects/colorgame/index.html',
      github: ''
    },
    {
      id: 12,
      title: 'Random User Generator',
      short_desc: 'Javascript + Ajax',
      slug: 'thumb_12',
      modalRequired: false,
      alt: 'Random User Generator Card',
      url: 'http://www.clearorb.com/projects/randomuser/index.html',
      github: 'https://github.com/Miario/Random_User'
    }
  ];
  


// WEBPACK FOOTER //
// ./src/components/Main/Card/cardInfo.js